<div class="main-container">
    <br><br>
    <div class="carousel-container">
        <div id="compressorCarousel" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <h1 class="title">AIR DRYER</h1>
                    <img src="../../../assets/img/active-product/air-dryer-product.jpeg" style="border-radius: 15px; box-shadow: 10px;"  height="50%" width="50%">
                </div>
            </div>
            <div>
            <div class="contact-info">
                <a href="tel:8489359948" class="contact-btn phone-btn">
                    <span class="fa fa-phone"></span> Call Now
                </a>
                <a href="mailto:rvproduction2017@gmail.com" class="contact-btn email-btn">
                    <span class="fa fa-envelope"></span> Email Us
                </a>
                <a href="https://wa.me/8489359948" target="_blank" class="contact-btn whatsapp-btn">
                    <span class="fa fa-whatsapp"></span> WhatsApp
                </a>
            </div>
        </div>
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="../../assets/img/active-product/animationproduct9.jpg" style="border-radius: 15px; box-shadow: 10px;"  height="50%" width="50%">
                </div>
            </div>
            <a class="carousel-control-prev" href="#compressorCarousel" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#compressorCarousel" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>

    <!-- Contact Information Section (Second Section) -->

    <!-- Multi Brand Piston Compressor Title and Tagline (Third Section) -->
    <div class="header">
       
        <p class="tagline">Efficient, Reliable, and Long-lasting Solutions for Compressed Air Drying</p>
        <p class="tagline1">
           <li> An air dryer is an essential component used to remove moisture from compressed air systems, ensuring the air is dry and clean for downstream equipment.</li>
        </p>
        <p class="tagline1">
           <li> It helps prevent corrosion, rust, and damage to air tools, pipes, and machinery caused by excess moisture in the air.</li>
        </p>
        <p class="tagline1">
            <li>Air dryers are critical in industries such as pharmaceuticals, food processing, and electronics, where dry air is necessary for product quality and equipment longevity.</li>
        </p>
        <p class="tagline1">
            <li> There are different types of air dryers, including refrigerated, desiccant, and membrane air dryers, each serving specific needs depending on the application and required dew point.</li>
        </p>
        <p class="tagline1">
           <li> A refrigerated air dryer uses a cooling process to condense water vapor, while a desiccant air dryer utilizes moisture-absorbing materials for more extreme drying needs.</li>
        </p>
        <p class="tagline1">
           <li> Air dryers offer benefits such as improved efficiency, extended equipment lifespan, and reduced downtime due to moisture-related issues in compressed air systems.</li>
        </p>
    </div>
    

    <!-- Feature Highlights Section (Last Section) -->
    <div class="feature-highlights">
        <div class="feature-card">
            <i class="fa fa-cogs"></i>
            <h4 class="font-weight-bold">Quick Response</h4>
            <p>We respond quickly to minimize downtime.</p>
        </div>
        <div class="feature-card">
            <i class="fa fa-check-circle"></i>
            <h4 class="font-weight-bold">Genuine Parts</h4>
            <p>We only use OEM parts for reliability.</p>
        </div>
    </div>

</div>
